var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.params.id)?_c('router-link',{attrs:{"to":_vm.link,"target":_vm.target}},[_vm._v(" "+_vm._s(_vm.params.internalNumber)+_vm._s(_vm.archivedLabel)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }